// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-04608481]:export {\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n  subMenuActiveText: #f4f4f5;\n  menuBg: #304156;\n  menuHover: #263445;\n  subMenuBg: #1f2d3d;\n  subMenuHover: #001528;\n  sideBarWidth: 210px;\n}\n.offer_content .unit[data-v-04608481] {\n  position: absolute;\n  margin-left: 1em;\n}\n.num_input[data-v-04608481] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
